module.exports = __webpack_public_path__ + "img/w3_circle_trash_recover_black.fc70d03a.png";